import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable()
export class LoginGuard implements CanActivate {
  private readonly _authService = inject(AuthService);
  private readonly _router = inject(Router);

  canActivate() {
    const token = localStorage.getItem("token");
      if (token && this._authService.checkTokenExpiry(token)) {
        this._router.navigate(["login"]);
      return false;
    }
    return true;
  }
}